module.exports = __webpack_public_path__ + "img/step4.dd1c932e.png";